import { useState } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import SubscriptionsIcon from "@mui/icons-material/Subscriptions"
import { CircularProgress } from "@mui/material"
import useAxiosPrivate from "../../../hooks/useAxiosPrivate"
import MessageModal from "../../../components/MessageModal"
import { createStripePortal } from "../services/profileService"
import { useAuth } from "../../../contexts/AuthContext"
import { useMutation } from "@tanstack/react-query"

export default function ManageSubscription() {
    const [manageDisabled, setManagedDisabled] = useState(false)
    const [message, setMessage] = useState(null)
    const axiosPrivate = useAxiosPrivate()
    const { auth } = useAuth()
    const { mutate } = useMutation({
        mutationFn: () =>
            createStripePortal({
                axiosPrivate,
                token: auth?.token,
                prevUrl: window.location.href,
            }),
        onSuccess: (portalURL) => {
            window.location.href = portalURL?.url
        },
        onError: (error) => {
            setMessage({
                type: "Unable to comply...",
                text: `Error creating customer portal session: ${
                    error?.response?.data?.message || error?.message || error
                }`,
            })
        },
        onSettled: () => {
            setManagedDisabled(false)
        },
    })

    async function handleClick() {
        setManagedDisabled(true)
        return mutate()
    }

    return (
        <Box sx={{ width: { xs: "100%", sm: "fit-content" } }}>
            <Button
                sx={{
                    width: { xs: "100%", sm: "fit-content" },
                    mt: { xs: 2, sm: 0 },
                    mb: { xs: 2, sm: 0 },
                    ml: { xs: 0, sm: 1, md: 3 },
                    mr: { xs: 0, sm: 1, md: 3 },
                }}
                variant="outlined"
                startIcon={
                    manageDisabled ? (
                        <CircularProgress size={20} />
                    ) : (
                        <SubscriptionsIcon />
                    )
                }
                onClick={handleClick}
                disabled={manageDisabled}
            >
                MANAGE SUBSCRIPTION
            </Button>
            {message && (
                <MessageModal message={message} setMessage={setMessage} />
            )}
        </Box>
    )
}
